/**
 * HomeStageSkeleton — the ordered top-level layer slots of the home
 * container ($homeContainer).
 *
 * Builds the four slot containers (see HomeStageSlots) and mounts them as the
 * first children of $homeContainer, in z-order (child order = draw order):
 *
 *   1. guides     — debug/guide graphics (grid-target dots, zone + hit-test guides)
 *   2. itemsPass1 — the first pass of big timeline items (JSON order)
 *   3. webglMain  — the particle fields (home field + spaces grid field);
 *                   ParticlesStage builds the home sub-tree inside the home
 *                   field's particle container
 *   4. itemsPass2 — the second (parallax) pass of big timeline items; this is
 *                   the ex-globals.pass2Container role — the skeleton owns its
 *                   mounting (last, above the fields), the timeline only keeps
 *                   the globals reference alive for its readers
 *
 * IMPORTANT: this order is load-bearing for the home visuals. It reproduces
 * the effective render order that previously emerged from ad-hoc addChild
 * calls (guides first, pass-1 items, the fields, then pass2Container re-added
 * last by each field constructor).
 */
import type { HomeStageSlots } from 'app/views/home/webgl/webgl.types';

export class HomeStageSkeleton {
	private _slots: HomeStageSlots;

	constructor($homeContainer: PIXI.Container) {
		const guides = new PIXI.Container();
		guides.name = 'guides';

		const itemsPass1 = new PIXI.Container();
		itemsPass1.name = 'itemsPass1';

		const webglMain = new PIXI.Container();
		webglMain.name = 'webglMain';

		const itemsPass2 = new PIXI.Container();
		itemsPass2.name = 'itemsPass2';

		$homeContainer.addChild(guides, itemsPass1, webglMain, itemsPass2);

		this._slots = { guides, itemsPass1, webglMain, itemsPass2 };
	}

	//GETTER / SETTER
	//-------------------------------------------------------------------------------------
	public get slots(): HomeStageSlots {
		return this._slots;
	}
}
